import { useState } from "react";
import { Bell, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { http, formatApiError } from "@/lib/api";

export function NotifyMe({ productId, shade, dark = false }) {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");
  const slug = `${productId}-${shade.toLowerCase().replace(/\s+/g, "-")}`;

  const submit = async (e) => {
    e.preventDefault();
    setState("loading");
    try {
      await http.post("/restock", { email, product_id: productId, shade });
      setState("done");
      toast.success(`We'll email you when ${shade} is back`);
    } catch (err) {
      setState("idle");
      toast.error(formatApiError(err));
    }
  };

  const box = dark ? "bg-[#FAF7F2]/10 border-[#EBB1B6]/40 text-[#FAF7F2] placeholder:text-[#D9C4BC]" : "bg-white border-[#E6D7CC] text-[#281715] placeholder:text-[#6E504A]";
  const btn = dark ? "bg-[#EBB1B6] text-[#281715] hover:bg-[#FAF7F2]" : "bg-[#281715] text-[#FAF7F2] hover:bg-[#4A2E2B]";

  if (state === "done")
    return (
      <p className={`flex items-center gap-2 text-sm ${dark ? "text-[#EBB1B6]" : "text-[#4A2E2B]"}`} data-testid={`notify-done-${slug}`}>
        <Check className="w-4 h-4" /> You're on the list for {shade}.
      </p>
    );

  return (
    <form onSubmit={submit} className="w-full" data-testid={`notify-form-${slug}`}>
      <p className={`text-sm mb-2 ${dark ? "text-[#D9C4BC]" : "text-[#6E504A]"}`}><span className={dark ? "text-[#EBB1B6]" : "text-[#B4566A]"}>Sold out.</span> Get an email when {shade} is back.</p>
      <div className="flex gap-2">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" data-testid={`notify-email-${slug}`}
          className={`flex-1 min-w-0 h-11 rounded-full border px-4 text-sm outline-none transition-colors duration-200 ${box}`} />
        <button disabled={state === "loading"} data-testid={`notify-submit-${slug}`}
          className={`shrink-0 h-11 rounded-full px-4 text-sm flex items-center gap-1.5 transition-colors duration-200 ${btn}`}>
          {state === "loading" ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Bell className="w-4 h-4" /> Notify me</>}
        </button>
      </div>
    </form>
  );
}
